import { render, staticRenderFns } from "./GideQuizLeaderBoard.vue?vue&type=template&id=750990d3&scoped=true"
import script from "./GideQuizLeaderBoard.vue?vue&type=script&lang=js"
export * from "./GideQuizLeaderBoard.vue?vue&type=script&lang=js"
import style0 from "./GideQuizLeaderBoard.vue?vue&type=style&index=0&id=750990d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750990d3",
  null
  
)

export default component.exports